<template>
    <div class="logo text-3xl">
        <span class="text-black dark:text-white">nano</span>
        <span class="text-brand-primary-500 font-bold">sites</span>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: 'Logo',
})
</script>

<style scoped>

</style>
